/**
 * Các trường bộ lọc nâng cao — giá, diện tích, phòng, tiện ích.
 *
 * Luồng dữ liệu:
 * - Component presentational: nhận filters và callbacks từ HeaderSearch.
 * - onUpdateFilter/onPricePresetChange bubble lên parent cập nhật state filters.
 * - variant 'sheet' thay đổi layout cho panel mobile.
 */
import { FilterAmenityChips } from './FilterAmenityChips';

import { RoomSpecField } from '../admin/RoomSpecField';

import {

  AREA_MAX_OPTIONS,

  AREA_MIN_OPTIONS,

  ROOM_SPEC_FILTER_FIELDS,

} from '../../shared/constants/property';



const FilterSection = ({ label, className = '', children }) => (

  <section className={`search-filter-section ${className}`.trim()}>

    <h3 className="search-filter-section__title">{label}</h3>

    <div className="search-filter-section__body">{children}</div>

  </section>

);



const FilterSectionCard = ({ label, className = '', children }) => (

  <section className={`search-filter-sheet-card ${className}`.trim()}>

    <h3 className="search-filter-sheet-card__title">{label}</h3>

    <div className="search-filter-sheet-card__body">{children}</div>

  </section>

);



const PriceChip = ({ active, children, onClick }) => (

  <button type="button" className={`search-filter-chip ${active ? 'is-active' : ''}`} onClick={onClick}>

    {children}

  </button>

);



const PricePresetRow = ({ options, value, onSelect }) => (

  <div className="search-filter-chip-row">

    {options.map((option) => (

      <PriceChip

        key={option.value || 'any'}

        active={value === option.value}

        onClick={() => onSelect(option.value)}

      >

        {option.label}

      </PriceChip>

    ))}

  </div>

);



const AreaSelect = ({ label, value, options, placeholder, onChange }) => (

  <label className="search-filter-select-field">

    <span className="search-filter-select-field__label">{label}</span>

    <select

      className="search-filter-select"

      value={value}

      onChange={(event) => onChange(event.target.value)}

    >

      <option value="">{placeholder}</option>

      {options.map((option) => (

        <option key={option.value} value={option.value}>

          {option.label}

        </option>

      ))}

    </select>

  </label>

);



const RoomSpecFilters = ({ filters, onUpdateFilter, quantityLabel }) => (

  <div className="filter-room-spec-grid">

    {ROOM_SPEC_FILTER_FIELDS.map(({ field, label }) => (

      <RoomSpecField

        key={field}

        label={label}

        value={filters[field]}

        quantityLabel={quantityLabel}

        onChange={(nextValue) => onUpdateFilter(field, nextValue === '' ? '' : String(nextValue))}

      />

    ))}

  </div>

);



const AmenityFilters = ({ filters, onUpdateFilter }) => (

  <FilterAmenityChips filters={filters} onUpdateFilter={onUpdateFilter} />

);



export const SearchFilterFields = ({

  filters,

  pricePreset,

  onUpdateFilter,

  onPricePresetChange,

  filterText,

  searchBarText,

  common,

  variant = 'default',

}) => {

  /** true khi render trong sheet mobile — áp dụng class layout khác */

  const isSheet = variant === 'sheet';



  if (isSheet) {

    return (

      <div className="search-filter-panel search-filter-panel--sheet">

        <FilterSectionCard label={searchBarText.priceLabel}>

          <PricePresetRow

            options={searchBarText.pricePresets}

            value={pricePreset}

            onSelect={onPricePresetChange}

          />

        </FilterSectionCard>



        <FilterSectionCard label={filterText.groupDimensions} className="search-filter-sheet-card--area">

          <div className="search-filter-area-pair search-filter-area-pair--sheet">

            <AreaSelect

              label={filterText.minAreaLabel}

              value={filters.min_area}

              options={AREA_MIN_OPTIONS}

              placeholder={common.unlimited}

              onChange={(value) => onUpdateFilter('min_area', value)}

            />

            <AreaSelect

              label={filterText.maxAreaLabel}

              value={filters.max_area}

              options={AREA_MAX_OPTIONS}

              placeholder={common.unlimited}

              onChange={(value) => onUpdateFilter('max_area', value)}

            />

          </div>

        </FilterSectionCard>



        <FilterSectionCard label={filterText.groupRoomSpecs} className="search-filter-sheet-card--rooms">

          <RoomSpecFilters

            filters={filters}

            onUpdateFilter={onUpdateFilter}

            quantityLabel={filterText.roomSpecQuantityLabel}

          />

        </FilterSectionCard>



        <FilterSectionCard label={filterText.groupAmenities} className="search-filter-sheet-card--amenities">

          <AmenityFilters filters={filters} onUpdateFilter={onUpdateFilter} />

        </FilterSectionCard>

      </div>

    );

  }



  return (

    <div className="search-filter-panel">

      <div className="search-filter-panel__primary">

        <FilterSection label={searchBarText.priceLabel}>

          <PricePresetRow

            options={searchBarText.pricePresets}

            value={pricePreset}

            onSelect={onPricePresetChange}

          />

        </FilterSection>



        <FilterSection label={filterText.groupDimensions} className="search-filter-section--area">

          <div className="search-filter-area-pair">

            <AreaSelect

              label={filterText.minAreaLabel}

              value={filters.min_area}

              options={AREA_MIN_OPTIONS}

              placeholder={common.unlimited}

              onChange={(value) => onUpdateFilter('min_area', value)}

            />

            <AreaSelect

              label={filterText.maxAreaLabel}

              value={filters.max_area}

              options={AREA_MAX_OPTIONS}

              placeholder={common.unlimited}

              onChange={(value) => onUpdateFilter('max_area', value)}

            />

          </div>

        </FilterSection>

      </div>



      <div className="search-filter-panel__features">

        <FilterSection label={filterText.groupRoomSpecs}>

          <RoomSpecFilters

            filters={filters}

            onUpdateFilter={onUpdateFilter}

            quantityLabel={filterText.roomSpecQuantityLabel}

          />

        </FilterSection>



        <FilterSection label={filterText.groupAmenities} className="search-filter-section--amenities">

          <AmenityFilters filters={filters} onUpdateFilter={onUpdateFilter} />

        </FilterSection>

      </div>

    </div>

  );

};

